import React, { useContext } from "react";
import "./Accordion.scss";

import {
  Accordion as MuiAccordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";

import AppContext from "../../../context/appContext";
import {
  accordionSXProps,
  sharedAtSXProps,
  summarySXProps,
  titleSXProps,
} from "./styles";

export function Accordion({ title, children, lastSharedAt }) {
  const [isOpen, setIsOpen] = React.useState(false);

  const appContext = useContext(AppContext);

  return (
    <MuiAccordion
      sx={accordionSXProps}
      expanded={isOpen}
      onChange={() => setIsOpen(!isOpen)}
      timeout={100}
    >
      <AccordionSummary
        sx={summarySXProps}
        expandIcon={<div className="itemArrow" />}
      >
        <Typography sx={titleSXProps}>{title}</Typography>

        <Typography sx={sharedAtSXProps}>
          {`Compartilhado em: ${appContext.convertDatePtBr(lastSharedAt)}`}
        </Typography>
      </AccordionSummary>

      <AccordionDetails
        sx={{ backgroundColor: "#fff", padding: "0" }}
        textAlign="right"
      >
        {children}
      </AccordionDetails>
    </MuiAccordion>
  );
}
